import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { SigninComponent } from "./c9901-signin/signin.component";
import { ChangepwComponent } from "./c9901-signin/changepw.component";
import { AdminComponent } from "./a0100-admin/admin.component";
import { EventComponent } from "./a0101-event/event.component";
import { QuestionCategoryComponent } from "./a0102-question-category/question-category.component";
import { QuestionListComponent } from "./a0104-question-list/question-list.component";
import { QuestionRegisterComponent } from "./a0103-question-register/question-register.component";
import { LanguageComponent } from "./a0109-language/language.component";
import { MailComponent } from "./a0106-mail/mail.component";
import { ProgressComponent } from "./a0107-progress/progress.component";
import { PersonComponent } from "./a0108-person/person.component";
import { ContractCompanyComponent } from "./a0120-contract-company/contract-company.component";
import { AbrSystemComponent } from "./c9900-abr-system/abr-system.component";
import { InputHistoryComponent } from "./a0115-input-history/input-history.component";
import { OutputHistoryComponent } from "./a0119-output-history/output-history.component";
import { MailHistoryComponent } from "./a0116-mail-history/mail-history.component";
import { AccessLogComponent } from "./a0117-access-log/access-log.component";
import { AccountListComponent } from "./a0118-account-list/account-list.component";
import { ContractCompanyListComponent } from "./a0120-contract-company/contract-company-list.component";

import { A0112AnswerStartPreviewComponent } from "./a0112-answer-preview/a0112-answer-start-preview.component";
import { A0112AnswerMainPreviewComponent } from "./a0112-answer-preview/a0112-answer-main-preview.component";
import { A0112ConfirmPreviewComponent } from "./a0112-answer-preview/a0112-confirm-preview.component";
import { A0114ResultAnalysisComponent } from "./a0114-result-analysis/a0114-result-analysis.component";

import { B0101AnswerComponent } from "./b0101-answer/b0101-answer.component";
import { B0001HomeComponent } from "./b0001-home/b0001-home.component";
import { B0102AnswerComponent } from "./b0102-answer/b0102-answer.component";
import { B0103ConfirmComponent } from "./b0103-confirm/b0103-confirm.component";
//ユーザー結果ダウンロード追加202409
import { KekkaDownloadComponent } from "./b0104-kekka-download/kekka-download.component";

import { MaintenanceComponent } from "./a0110-maintenance/maintenance.component";
import { MCompanyComponent } from "./a0121-mcompany/mcompany.component";
import { MJigyobaComponent } from "./a0122-mjigyoba/mjigyoba.component";
import { MSyokubaComponent } from "./a0123-msyokuba/msyokuba.component";
import { MSyozokuComponent } from "./a0124-msyozoku/msyozoku.component";
import { MJigyosyoComponent } from "./a0125-mjigyosyo/mjigyosyo.component";
import { MYakusyokuComponent } from "./a0126-myakusyoku/myakusyoku.component";
import { MShikakuComponent } from "./a0127-mshikaku/mshikaku.component";
import { MSyokusyuComponent } from "./a0128-msyokusyu/msyokusyu.component";
import { MMibunComponent } from "./a0129-mmibun/mmibun.component";
import { MCourseComponent } from "./a0130-mcourse/mcourse.component";

import { YoyakuHyoComponent } from "./a2102-yoyaku-hyo/yoyaku-hyo.component";
import { YoyakuListComponent } from "./a2104-yoyaku-list/yoyaku-list.component";
import { YoyakuRegisterComponent } from "./a2103-yoyaku-register/yoyaku-register.component";
import { YoyakuAcceptListComponent } from "./a2105-yoyaku-accept-list/yoyaku-accept-list.component";
import { YoyakuMaintenanceComponent } from "./a2120-yoyaku-maintenance/yoyaku-maintenance.component";
import { YTimeaxisListComponent } from "./a2121-ytimeaxis-list/ytimeaxis-list.component";
import { YTimeaxisComponent } from "./a2122-ytimeaxis/ytimeaxis.component";
import { YDivision1Component } from "./a2123-ydivision1/ydivision1.component";
import { YDivision2Component } from "./a2124-ydivision2/ydivision2.component";
import { YConditionsGroupSComponent } from "./a2125-yconditions-group-s/yconditions-group-s.component";
import { YConditionsGroupMComponent } from "./a2126-yconditions-group-m/yconditions-group-m.component";
import { YConditionsGroupLComponent } from "./a2127-yconditions-group-l/yconditions-group-l.component";

import { B0202YoyakuComponent } from "./b0202-yoyaku/b0202-yoyaku.component";
import { B0203ConfirmComponent } from "./b0203-confirm/b0203-confirm.component";
import { A2112YoyakuMainPreviewComponent } from "./a2112-yoyaku-preview/a2112-yoyaku-main-preview.component";
import { A2112ConfirmPreviewComponent } from "./a2112-yoyaku-preview/a2112-confirm-preview.component";

import { AuthGuard } from "./service/auth.guard";
import { infoComponent } from "./c9903-info/info.component";

//ユーザー結果ダウンロード追加202510マイナビ
import { KekkaUploadComponent } from "./b0105-kekka-upload/kekka-upload.component";
import { UploadSettingComponent } from "./a2128-upload-setting/upload-setting.component";
import { KenshinkekkaUploadComponent } from "./b0106-kenshinkekka-upload/kenshinkekka-upload.component";

const routes: Routes = [
  //空の時
  { path: "", component: infoComponent, pathMatch: "full" },
  //指定ページ
  { path: "signin", component: infoComponent, pathMatch: "full" },
  { path: "signin/:kcd", component: SigninComponent },
  {
    path: "fpassword",
    component: ChangepwComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "cpassword",
    component: ChangepwComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "apassword",
    component: ChangepwComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "event",
    component: EventComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "question-category/:eid",
    component: QuestionCategoryComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "question-list/:qcid/:lid",
    component: QuestionListComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "question-register/:qcid/:qid/:lid/:ro",
    component: QuestionRegisterComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "language",
    component: LanguageComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "contract-company",
    component: ContractCompanyComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "mail/:eid",
    component: MailComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "progress/:eid",
    component: ProgressComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "person/:eid",
    component: PersonComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "home",
    component: B0001HomeComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "answer/start",
    component: B0101AnswerComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "answer/main",
    component: B0102AnswerComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "answer/confirm",
    component: B0103ConfirmComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  //ユーザー結果ダウンロード追加202409
  {
    path: "kekka",
    component: KekkaDownloadComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  //ユーザー結果ダウンロード追加202409
  {
    path: "upload/:tpid",
    component: KekkaUploadComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "kenshin-upload/:eid/:tpid",
    component: KenshinkekkaUploadComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "answer-preview/start",
    component: A0112AnswerStartPreviewComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "answer-preview/main",
    component: A0112AnswerMainPreviewComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "answer-preview/confirm",
    component: A0112ConfirmPreviewComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "result-analysis/:qcid/:lid",
    component: A0114ResultAnalysisComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },

  {
    path: "maintenance/:eid",
    component: MaintenanceComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/company/:eid",
    component: MCompanyComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/jigyoba/:eid",
    component: MJigyobaComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/syokuba/:eid",
    component: MSyokubaComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/syozoku/:eid",
    component: MSyozokuComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/jigyosyo/:eid",
    component: MJigyosyoComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/yakusyoku/:eid",
    component: MYakusyokuComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/shikaku/:eid",
    component: MShikakuComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/syokusyu/:eid",
    component: MSyokusyuComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/mibun/:eid",
    component: MMibunComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "m/course/:eid",
    component: MCourseComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },

  {
    path: "yoyaku-hyo/:eid",
    component: YoyakuHyoComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "upload-setting/:eid",
    component: UploadSettingComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "yoyaku-list/:yhid",
    component: YoyakuListComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "yoyaku-register/:yhid",
    component: YoyakuRegisterComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "yoyaku-accept-list",
    component: YoyakuAcceptListComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "yoyaku-maintenance",
    component: YoyakuMaintenanceComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/timeaxis-list",
    component: YTimeaxisListComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/timeaxis/:tid",
    component: YTimeaxisComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/division1",
    component: YDivision1Component,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/division2/:did",
    component: YDivision2Component,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/conditions-group-s",
    component: YConditionsGroupSComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/conditions-group-m",
    component: YConditionsGroupMComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "y/conditions-group-l",
    component: YConditionsGroupLComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },

  {
    path: "yoyaku/main",
    component: B0202YoyakuComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },
  {
    path: "yoyaku/confirm",
    component: B0203ConfirmComponent,
    canActivate: [AuthGuard],
    data: { role: 1 },
  },

  {
    path: "yoyaku-preview/main",
    component: A2112YoyakuMainPreviewComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "yoyaku-preview/confirm",
    component: A2112ConfirmPreviewComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },

  {
    path: "system",
    component: AbrSystemComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },
  {
    path: "input-history/:mode",
    component: InputHistoryComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },
  {
    path: "ainput-history/:mode",
    component: InputHistoryComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },
  {
    path: "output-history/:mode",
    component: OutputHistoryComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },
  {
    path: "aoutput-history/:mode",
    component: OutputHistoryComponent,
    canActivate: [AuthGuard],
    data: { role: 2 },
  },

  {
    path: "mail-history/:mode",
    component: MailHistoryComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },
  {
    path: "access-log/:mode",
    component: AccessLogComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },
  {
    path: "account-list/:mode",
    component: AccountListComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },

  {
    path: "contract-company-list",
    component: ContractCompanyListComponent,
    canActivate: [AuthGuard],
    data: { role: 999 },
  },

  //該当しない時
  { path: "**", component: infoComponent, pathMatch: "full" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
      useHash: true,
      //enableTracing: true  //<-- debugging purposes only
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts